import * as I18n from 'circe/I18n';
import moment from 'moment';
import { SHIPMENT_STATUS } from '../constants';

export const getTruckName = (vehicleType, state) => (state.app.order.categories[vehicleType]
  ? state.app.order.categories[vehicleType].name
  : vehicleType);

export const isShipmentTrackable = (status, currentLocation) => currentLocation
  && [SHIPMENT_STATUS.IN_ROUTE, SHIPMENT_STATUS.LOADING, SHIPMENT_STATUS.UN_LOADING].includes(status);
export const isCancelled = (status) => status === 'CANCELLED';

export const morphShipmentToUI = (shipment) => {
  const expectedDelivery = shipment.dropoff.arrivalWindow.begin;
  const date = moment(expectedDelivery);

  const volume = shipment.load.items[0].dimensions.height
    * shipment.load.items[0].dimensions.width
    * shipment.load.items[0].dimensions.length;
  const weight = shipment.load.items[0].mass;
  const { quantity } = shipment.load.items[0];
  const title = shipment.load.description;

  const equipments = getShipmentEquipments(shipment);

  return {
    summary: {
      location: shipment.location,
      equipments,
      weight: {
        value: shipment.load.items[0].mass,
        unit: 'KG',
      },
      volume: {
        value: volume,
        unit: 'CBM',
      },
      items: [
        {
          quantity,
          volume: `${(volume * quantity).toFixed(4)} CBM`,
          weight: `${weight * quantity} KG`,
          title,
        },
      ],

      pickup: {
        name: shipment.pickup.description,
        date: moment(shipment.pickup.arrivalWindow.begin).format('DD/MM/YYYY HH:mm'),
        address: shipment.pickup.address,
        location: {
          lat: shipment.pickup.coordinate.latitude,
          lng: shipment.pickup.coordinate.longitude,
        },
        contact: shipment.sender,
        profileId: shipment.senderId,
        phone: shipment.senderPhone,
      },

      delivery: {
        stops: [
          {
            name: shipment.dropoff.description,
            date: moment(shipment.dropoff.arrivalWindow.begin).format('DD/MM/YYYY HH:mm'),
            address: shipment.dropoff.address,
            location: {
              lat: shipment.dropoff.coordinate ? shipment.dropoff.coordinate.latitude : 0,
              lng: shipment.dropoff.coordinate ? shipment.dropoff.coordinate.longitude : 0,
            },
            contact: shipment.receiver,
            phone: shipment.receiverPhone,
          },
        ],
      },
      shipmentValue: shipment.load.value,
      distance: I18n.str('na', 'N/A'),
      duration: I18n.str('na', 'N/A'),
    },
    quote: {
      waybill: shipment.waybill,
      status: shipment.status,
      shipmentId: shipment.shipmentId,
      itineraryId: shipment.itineraryId,
      driver: {
        ...shipment.driver,
        vehicle: {
          type: shipment.vehicle.vehicleType,
          maxWeight: shipment.vehicle.maxWeight,
          dimensions: { ...shipment.vehicle.size },
          id: shipment.vehicle.id,
        },
      },
      fees: shipment.pricing.salesInvoice.lineItems,
      expectedDelivery: {
        date: date.format('DD/MM/YYYY'),
        time: date.format('HH:mm'),
      },
      price: {
        amount: shipment.pricing.salesInvoice.total,
        currency: shipment.pricing.salesInvoice.currency,
      },
      policies: [],
      notes: shipment.load.description,
      addressStatus: shipment.addressStatus,
    },
  };
};

const getShipmentEquipments = (shipment) => [
  {
    truck: shipment.vehicle.vehicleType,
    capacity: shipment.vehicle.maxWeight,
  },
];

export const morphEquipmentsUsingState = (equipments, vehicle, state) => equipments.map((equipment) => {
  const truck = state.app.order.categories[equipment.truck];
  let capacityName = `${vehicle.maxWeight / 1000} ${I18n.str('ton', 'Ton')}`;
  if (equipment.capacity >= 25000) {
    capacityName = `${I18n.str('moreThan25Ton', '> 25 Ton')}`;
  }
  const capacityId = `${truck._id}_${equipment.capacity}`;
  return {
    truckId: truck._id,
    capacityId,
    capacityName,
    truckName: truck.name,
    quantity: 1,
    image: truck.image,
  };
});

export const morphUsingState = (shipment, state) => {
  const { vehicle } = shipment.quote.driver;

  const equipments = morphEquipmentsUsingState(shipment.summary.equipments, vehicle, state);

  let truckImage = equipments.length > 0 ? equipments[0].image : null;

  truckImage = truckImage || require('assets/img/defaultTruck.svg');

  return {
    ...shipment,
    summary: {
      ...shipment.summary,
      equipments,
      truckImage,
    },
  };
};

export const morphOriginalResponseUsingState = (shipment, state) => ({
  ...shipment,
  equipments: morphEquipmentsUsingState(getShipmentEquipments(shipment), shipment.vehicle, state),
});
